export default __webpack_public_path__ + "static/cluster-colors-aae0de810dc6d664b8040fd343cacfb7.svg";